import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-textbox',
  templateUrl: './formly-textbox.component.html',
  styleUrls: ['./formly-textbox.component.scss'],
})
export class FormlyTextboxComponent extends FieldType {
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation()
    }
  }
}
